import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { DisconnectSVG } from '@common_components/svg/disconnect.svg';

const DisconnectIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <DisconnectSVG/>
    </div>
  );
};

export { DisconnectIcon };
